<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["options", "dailyData", "thisMonthsDaysArr"],
  data() {
    return {};
  },
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        labels: this.thisMonthsDaysArr,
        datasets: [
          {
            label: `Kuluvan kuukauden päivittäinen myynti`,
            backgroundColor: "#f87979",
            data: this.dailyData,
          },
        ],
      },
      this.options
    );
  },
};
</script>

<style></style>
